const store = {
  namespaced: true,
  state: {
    token: null,
    usuario: null,
    modulos: []
  },
  mutations: {
    setToken(state, token) {
      let claims = token.split(".")[1];
      let base64 = claims.replace(/-/g, "+").replace(/_/g, "/");
      let usuarioStr = decodeURIComponent(
        atob(base64)
          .split("")
          .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );

      let usuario = JSON.parse(usuarioStr);
      state.token = token;
      state.usuario = {
        name: usuario.name,
        perms: usuario.perms
      };
    },
    setModulos(state, modulos) {
      state.modulos = modulos;
    },
    cerrarSesion(state) {
      state.token = null;
      state.usuario = null;
      localStorage.removeItem("seguridad");
      sessionStorage.removeItem("seguridad");
    }
  }
};

export default store;
